import { Loader } from '@voghion/fe-util'
import { webpSupported } from './webp'

const allImages = import.meta.glob('../assets/images/**/*', {
  eager: true
})

const ratioExts = ['jpg', 'png', 'webp']

/**
 * 将路径 url 转为实际的图片 url
 * @param {*} url 路径
 * @param {*} ratio 缩放比
 * @param {*} ext 类型，如果是自动类型，按照 webp -> png -> jpg 的顺序查找
 * @returns
 */
export function convertStaticImage(url, ratio = 2, ext = 'auto') {
  if (!url.includes('assets/')) {
    return ''
  }
  const webp = webpSupported()
  const isAuto = ext === 'auto'
  if (isAuto) {
    if (url.endsWith('.svg')) {
      ext = 'svg'
    } else if (url.endsWith('.gif')) {
      ext = 'gif'
    } else {
      ext = webp ? 'webp' : 'png'
    }
  }
  const arr = url.split('assets/')
  const arr1 = arr[1].split('.')
  const imagepath = arr1.length > 1 ? arr1.slice(0, -1).join('.') : arr1.join('.')
  const ratioStr = ratioExts.includes(ext) && ratio > 1 ? `@${ratio}x` : ''
  let module = allImages[`../assets/${imagepath}${ratioStr}.${ext}`]
  if (!module && isAuto) {
    module = allImages[`../assets/${imagepath}${ratioStr}.png`]
    if (!module) {
      module = allImages[`../assets/${imagepath}${ratioStr}.jpg`]
    }
    if (!module) {
      module = allImages[`../assets/${imagepath.replace('images', 'images-legacy')}${ratioStr}.png`]
    }
  }
  return module ? module.default : ''
}

/**
 * 预加载静态图片
 * @param {*} url
 */
export const preloadStaticImage = (url) => {
  const loader = Loader.getInstance()
  const ratio = window.devicePixelRatio || 2
  const src = convertStaticImage(url, ratio > 2 ? 3 : 2)
  loader.loadImage(src)
}

/**
 * 批量预加载静态图片
 * @param {*} urls
 */
export const preloadStaticImages = (urls) => {
  const loader = Loader.getInstance()
  const ratio = window.devicePixelRatio || 2
  const srcs = []
  for (const url of urls) {
    srcs.push(convertStaticImage(url, ratio > 2 ? 3 : 2))
  }
  loader.loadImages(srcs)
}
